const PlatformType = {
  PLC: "plc",
  PLB: "plb",
  PLCandPLB: "plc-plb",
  VIP: "vip",
};

export default PlatformType;
